export default __webpack_public_path__ + "static/media/pdf-icon.ea7bb528.svg";